import type { PeriodKind } from '../lib/types';

interface Props {
  period: PeriodKind;
  referenceDate: string; // YYYY-MM-DD
}

const DOW = ['日', '月', '火', '水', '木', '金', '土'];

function isoWeekRange(date: Date): { start: Date; end: Date } {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  const isoDow = d.getUTCDay() === 0 ? 7 : d.getUTCDay();
  const monday = new Date(d);
  monday.setUTCDate(d.getUTCDate() - (isoDow - 1));
  const sunday = new Date(monday);
  sunday.setUTCDate(monday.getUTCDate() + 6);
  return { start: monday, end: sunday };
}

function md(d: Date) {
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()}`;
}

export function PeriodLabel({ period, referenceDate }: Props) {
  const d = new Date(referenceDate + 'T00:00:00Z');
  let text: string;
  if (period === 'today') {
    text = `${d.getUTCMonth() + 1}月${d.getUTCDate()}日(${DOW[d.getUTCDay()]})`;
  } else if (period === 'week') {
    const w = isoWeekRange(d);
    text = `${md(w.start)}(月)〜${md(w.end)}(日)`;
  } else {
    text = `${d.getUTCFullYear()}年${d.getUTCMonth() + 1}月`;
  }
  return (
    <div className="max-w-device w-full mx-auto px-5 pt-4 pb-2 font-serif text-2xl tracking-wide text-ink-900 dark:text-ink-50">
      {text}
    </div>
  );
}
